module.exports = __webpack_public_path__ + "media/app/images/mobile-success-9e656d943b6143063bc35c1bcef1b434.png";